import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Privacy Policy</h1>
      <p>Last Updated: 10 October 2025</p>

      <h2 className="font-semibold text-xl mt-6 mb-2">1. Introduction</h2>
      <p>
        Bricksnmix values your privacy. This Privacy Policy explains how we
        collect, store, use, and protect your information both online and
        offline.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">2. Information We Collect</h2>
      <p>
        We may collect personal details such as your name, phone number, email,
        address, order history, device information, and usage analytics.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">3. Offline Data Handling</h2>
      <p>
        While offline, Bricksnmix only stores essential order details on your
        device temporarily. No personal data is transmitted or uploaded until an
        active internet connection is restored.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">4. How We Use Your Data</h2>
      <ul className="list-disc ml-6">
        <li>To process and deliver orders</li>
        <li>To provide personalized recommendations</li>
        <li>To improve user experience</li>
        <li>To detect and prevent fraudulent activities</li>
      </ul>

      <h2 className="font-semibold text-xl mt-6 mb-2">5. Sharing of Data</h2>
      <p>
        We do not sell or rent your personal information. Data may be shared
        only with trusted partners involved in fulfilling your orders or legal
        requirements.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">6. Data Security</h2>
      <p>
        We use encryption and secure storage practices to protect your
        information from unauthorized access.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">7. Cookies & Tracking</h2>
      <p>
        We use cookies for login sessions, personalization, and analytics. You
        may disable cookies through browser settings.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">8. Your Rights</h2>
      <p>You can request data access, correction, or deletion at any time.</p>

      <h2 className="font-semibold text-xl mt-6 mb-2">9. Third-Party Links</h2>
      <p>
        Bricksnmix is not responsible for the privacy practices of external
        websites linked on our platform.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">10. Contact Us</h2>
      <p>
        For privacy concerns, reach us via our support team or partner stores.
      </p>
       <p className="mt-2">
        <strong>Address:</strong> <span>Panadan Villa's Rd, Vidya Nagar Colony,<br /> Corrazone,
        Kalamassery, Kochi, Kerala 682022 <br /></span>
        <strong>Phone:</strong> 7510882555 / 7510881555 <br />
        <strong>Email:</strong> bricksnmix@gmail.com
      </p>
    </div>
  );
};

export default PrivacyPolicy;
